import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './Speaking.css';

function Speaking() {
  const [featuredRef, featuredVisible] = useScrollReveal();

  return (
    <section className="speaking section" id="speaking">
      <div className="container">
        <h2 className="section-title">
          Hear Her <span className="gold-accent">Speak</span>
        </h2>
        <p className="section-subtitle">
          From TEDx to Fortune 500s, Miriam talks about rising extremism, antisemitism, and technology
        </p>

        <div ref={featuredRef} className={`speaking__featured reveal ${featuredVisible ? 'visible' : ''}`}>
          <div className="speaking__video">
            <div className="speaking__video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/QlSmCeZTVeE"
                title="TEDx Talk - Miriam Haart"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <div className="speaking__info">
            <span className="speaking__badge">TEDx Talk</span>
            <h3 className="speaking__talk-title">
              The SITT Test: Are You Really Thinking Freely?
            </h3>
            <p className="speaking__description">
              Miriam's powerful TEDx talk focuses on modern society's shift towards
              fundamentalist thinking, drawing from her own experience growing up in an
              ultra-Religious community and her studies at Stanford.
            </p>

            <div className="speaking__topics">
              <h4 className="speaking__topics-title">Speaking Topics</h4>
              <ul className="speaking__topics-list">
                <li>AI & The Future of Technology</li>
                <li>AI & The Future of Business</li>
                <li>Female Leadership in Tech</li>
                <li>Rising Extremism & Fundamentalist Thinking</li>

                <li>Breaking Free: From Ultra-Orthodoxy to Silicon Valley</li>
              </ul>
            </div>

            <a href="#contact" className="btn-primary">
              Book Miriam for Speaking
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Speaking;
